import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[appHideMe]'
})
export class HideMeDirective implements AfterViewInit {
    constructor(
        private el: ElementRef
    ) { }

    ngAfterViewInit() {
        this.el.nativeElement.style.display = 'none';
    }
}